<div class="loops-by-origin">
    <div class="chart-container" #chartTarget style="width: 100%"></div>
</div>
